import React, { useState } from 'react'
import { ExperimentOutlined } from '@ant-design/icons'
import { Modal, message } from 'antd'

import { useCaseViewContext } from '../../../context'
import { REQUEST_STATUS, CaseStatusEnum } from '../../../constants'
import { isSermorelinCategory } from './Labs'

export const RequestLabOrder = () => {
  const { 
    caseDetails, 
    activeRequest,
    apiType, 
    readOnlyMode,
    fetchCaseDetails,
    apiClasses,
  } = useCaseViewContext()

  const [loading, setLoading] = useState(false)

  if (apiType !== 'physician' || readOnlyMode) return null
  if (!isSermorelinCategory(caseDetails)) return null

  const caseAlreadyInLabFlow = caseDetails?.status === CaseStatusEnum.PENDING_LABS
  const requestStatus = activeRequest?.status || caseDetails?.requests?.at(-1)?.status
  const requestIsPending = requestStatus === REQUEST_STATUS.PENDING

  const completedStatuses = [CaseStatusEnum.CONSULT_COMPLETE, CaseStatusEnum.CONSULT_COMPLETE_NO_RX]
  const caseIsCompleted = completedStatuses.includes(caseDetails?.status)

  if (caseAlreadyInLabFlow || caseIsCompleted || !requestIsPending) return null

  const handleRequestLabOrder = () => {
    Modal.confirm({
      title: 'Request Lab Order',
      content: 'This will request an admin to order labs for this patient. The case will move to "pending labs" until results are received. Continue?',
      okText: 'Request Labs',
      cancelText: 'Cancel',
      onOk: async () => {
        setLoading(true)
        try {
          await apiClasses.PhysicianAPI.requestLabOrder(caseDetails.caseId || caseDetails._id)
          message.success('Lab order requested successfully')
          await fetchCaseDetails()
        } catch (err) {
          console.error('Error requesting lab order:', err)
          message.error(err.response?.data?.message || 'Failed to request lab order')
        } finally {
          setLoading(false)
        }
      },
    })
  }

  return (
    <div style={{ 
      width: '100%', 
      padding: '20px',
      marginBottom: '20px', 
      background: 'rgba(204, 125, 203, 0.15)', 
      color: '#000',
      borderRadius: '5px', 
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <ExperimentOutlined style={{ color: 'rgba(204, 125, 203, 1)', fontSize: '1.1rem' }} />
        <strong style={{ color: 'rgba(204, 125, 203, 1)', fontSize: '1.1rem' }}>Lab Order</strong>
      </div>
      <span style={{ fontSize: '0.9rem', color: '#555' }}>
        Optionally request labs for this patient. An admin will be notified to place the order.
      </span>
      <button
        id="request-lab-order-btn"
        onClick={handleRequestLabOrder}
        disabled={loading}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          padding: '6px 16px',
          border: 'none',
          borderRadius: '5px',
          backgroundColor: 'rgba(204, 125, 203, 1)',
          color: 'white',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1,
          fontSize: '13px',
          fontWeight: 500,
          alignSelf: 'flex-start',
          transition: 'opacity 0.2s',
        }}
      >
        <ExperimentOutlined />
        {loading ? 'Requesting...' : 'Request Lab Order'}
      </button>
    </div>
  )
}
